import React from 'react';
import { stageDetailText, noOverflow } from '../../../../themes/styles';
import moment from 'moment';
import theme from '../../../../themes/CBB/theme';
import Typography from '@material-ui/core/Typography';
import StageDateEdit from './StageDateEdit';
import StageDateLogo from './StageDateLogo';

export default function StageDate({
  stage,
  edit,
  handleStageUpdate,
  addOrDeleteError,
  setAutoSave = (arg) => {},
}) {
  let date = moment(stage.start);

  return (
    <>
      {edit && (
        <StageDateEdit
          stage={stage}
          handleStageUpdate={handleStageUpdate}
          addOrDeleteError={addOrDeleteError}
          setAutoSave={setAutoSave}
        />
      )}
      {!edit && (
        <>
          <StageDateLogo />
          <Typography
            variant="subtitle1"
            style={{ ...stageDetailText(theme), ...(noOverflow as object) }}
          >
            {date.format('MMM DD')}
          </Typography>
        </>
      )}
    </>
  );
}
